import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import CompanyLogo from "../images/logo_AC.avif";
import "./Navbar.css";
import { useAuth0 } from "@auth0/auth0-react";

const Navbar = () => {
  const { loginWithRedirect, logout, isAuthenticated, isLoading } = useAuth0();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  const closeMenu = () => setIsMenuOpen(false);

  const handleAuthClick = () => {
    closeMenu();

    if (!isAuthenticated) {
      loginWithRedirect();
      return;
    }

    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  if (isLoading) return null; // avoid flicker while Auth0 initializes

  return (
    <nav className={`navbar${isMenuOpen ? " navbar--open" : ""}`}>
      <div className="navbar__inner section-shell">
        <Link to="/" className="navbar__brand" aria-label="Ammen Consulting home" onClick={closeMenu}>
          <img src={CompanyLogo} alt="Ammen Consulting" />
          <span className="navbar__strap">Commercialization strategy for medtech teams</span>
        </Link>

        <button
          className="navbar__toggle"
          type="button"
          aria-label={isMenuOpen ? "Close navigation menu" : "Open navigation menu"}
          aria-expanded={isMenuOpen}
          aria-controls="primary-navigation"
          onClick={() => setIsMenuOpen((open) => !open)}
        >
          <span aria-hidden="true" />
          <span aria-hidden="true" />
          <span aria-hidden="true" />
        </button>

        <div className="navbar__actions" id="primary-navigation">
          <div className="navbar__meta">
            <span className="navbar__metaLabel">Since 2010</span>
            <span className="navbar__metaDivider" aria-hidden="true" />
            <span className="navbar__metaLabel">Sales operations + analytics</span>
          </div>

          <ul className="nav-links">
            <li>
              <NavLink
                to="/"
                className={({ isActive }) => (isActive ? "active" : undefined)}
                end
                onClick={closeMenu}
              >
                Home
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/past-clients"
                className={({ isActive }) => (isActive ? "active" : undefined)}
                end
                onClick={closeMenu}
              >
                Client History
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/testimonials"
                className={({ isActive }) => (isActive ? "active" : undefined)}
                end
                onClick={closeMenu}
              >
                Testimonials
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/staff"
                className={({ isActive }) => (isActive ? "active" : undefined)}
                end
                onClick={closeMenu}
              >
                Staff
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/contact"
                className={({ isActive }) => (isActive ? "active" : undefined)}
                onClick={closeMenu}
              >
                Contact
              </NavLink>
            </li>
            <li>
              {!isAuthenticated ? (
                <button
                  className="nav-login-button"
                  onClick={handleAuthClick}
                >
                  Client Login
                </button>
              ) : (
                <button
                  className="nav-login-button nav-login-button--active"
                  onClick={handleAuthClick}
                >
                  Logout
                </button>
              )}
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
